import React, { useState, useEffect,forwardRef } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import DatePicker from "react-datepicker";
import DatepickerWrapper from "components/forms/alldatepickers/datepicker.style";
import deviceDataCodes from './deviceDataCodes';

import "react-datepicker/dist/react-datepicker.css";


import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";

import { attr, setAttr } from "views/customer/app/AllDevices";


const ClientSideTable = props => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownName, setDropdownName] = useState("Level 1")
    const [columns, setColumns] = useState([{Header: "Cihaz Adı",accessor: "name",className: "text-center",headerClassName: "react-table-header-class"}])
    const [startDate, setStartDate] = useState(new Date());
    const [timeAttr, setTimeAttr] = useState('day')
    const [data, setData] = useState([]);

    var getMonthDates = function(startDate, endDate) {
        var dates = [],
            currentDate = startDate,
            addDays = function(days) {
              var date = new Date(this.valueOf());
              date.setDate(date.getDate() + days);
              return date;
            };
        while (currentDate <= endDate) {
          var _date = currentDate.getDate() < 10 ? ("0" + currentDate.getDate()) : currentDate.getDate();
          var _month = (parseInt(currentDate.getMonth() + 1)) < 10 ? ("0" + parseInt(currentDate.getMonth() + 1)) : (parseInt(currentDate.getMonth() + 1)) 
          dates.push(_date + "/" + _month);
          currentDate = addDays.call(currentDate, 1);
        }
        return dates;
    };
    var getWeekDates = function(startDate, endDate) {
        var dates = [],
            currentDate = startDate,
            addDays = function(days) {
              var date = new Date(this.valueOf());
              date.setDate(date.getDate() + days);
              return date;
            };
        while (currentDate <= endDate) {
          var _date = currentDate.getDate() < 10 ? ("0" + currentDate.getDate()) : currentDate.getDate();
          var _month = (parseInt(currentDate.getMonth() + 1)) < 10 ? ("0" + parseInt(currentDate.getMonth() + 1)) : (parseInt(currentDate.getMonth() + 1)) 
          dates.push(_date + "/" + _month + ' (ÖÖ)');
          dates.push(_date + "/" + _month + ' (ÖS)');
          currentDate = addDays.call(currentDate, 1);
        }
        return dates;
    };


    useEffect(() => {
        let _columns = [

        ]
        var d = new Date();
        var columnsArr = [];

        if (timeAttr === "day"){
            columnsArr = ["00","01","02","03","04","05","06","07","08","09","10","11"]
            _columns = [
                {
                    Header: "Cihaz Adı",
                    accessor: "name",
                    className: "text-center",
                    headerClassName: "react-table-header-class",
                    width: 300
                }
            ]
            columnsArr.map((arr, index) => {

                let start = (parseInt(arr) *2 ) < 10 ? ("0"+ (parseInt(arr)*2)) : (parseInt(arr)*2)
                let end = columnsArr[index+1] ? ((parseInt(columnsArr[index+1])*2 < 10 ? ("0" + (parseInt(columnsArr[index+1])*2)) : (parseInt(columnsArr[index+1])*2))) : "24"
                return _columns.push(
                    {
                        Header: start + ":00 - " + end +":00",
                        accessor: arr,
                        className: "text-center",
                        headerClassName: "react-table-header-class"
                    }
                )
                
            })
        } else if (timeAttr === "month") {
            
            var lastMonth = new Date(d.getFullYear(), d.getMonth()-1, d.getDate(), null, null);
            columnsArr = getMonthDates(lastMonth, d);
            
            columnsArr.map((arr) => {

                return _columns.push(
                    {
                        Header: arr,
                        accessor: arr,
                        className: "text-center",
                        headerClassName: "react-table-header-class"
                    }
                )
            })
            _columns = _columns.reverse();
            _columns = [
                {
                    Header: "Cihaz Adı",
                    accessor: "name",
                    className: "text-center",
                    headerClassName: "react-table-header-class",
                    width: 300
                }, ..._columns
            ]
        } else if (timeAttr === "week") {
            var lastWeek = new Date(d.getFullYear(), d.getMonth(), d.getDate()-7, null, null);
            columnsArr = getWeekDates(lastWeek, d);
            
            columnsArr.map((arr) => {
                return _columns.push(
                    {
                        Header: arr,
                        accessor: arr,
                        className: "text-center",
                        headerClassName: "react-table-header-class"
                    }
                )
            })
            _columns = _columns.reverse();
            _columns = [
                {
                    Header: "Cihaz Adı",
                    accessor: "name",
                    className: "text-center",
                    headerClassName: "react-table-header-class",
                    width: 300
                }, ..._columns
            ]

        }

        setColumns(_columns)
        let attrDevices = []
        if(props.devices.length) {
            props.devices.map((device, index) => {
                attrDevices[index] = []
                attrDevices[index]["name"] = device.name
                device.deviceData.map(val => {
                    if(val){
                        if(timeAttr === "month"){
                            if(val) attrDevices[index][val.date] = val.data;
                        } else if (timeAttr === "week") {
                            if(val[0]) attrDevices[index][val[0].date+ " (ÖÖ)"] = val[0].data;
                            
                            if(val[1]) attrDevices[index][val[1].date+ " (ÖS)"] = val[1].data;
        
                        } else if (timeAttr === "day") {
                            if(val && val.time){
                                let hour = parseInt(val.time.substr(0,2)/2);
                                hour = hour < 10 ? ("0"+hour) : hour;
                                attrDevices[index][hour] = val.data
                            }
                        }
                    }
                    return true

                })
                setData(attrDevices)
                return true;

            })
        }
        
    },[props.devices, timeAttr])

    const handleQuery = (query) => {
        if(query.time) {
            setAttr({...attr, "time": query.time})
        } else if(query.value) {
            setAttr({...attr, "value": query.value})
        }
    }
    const DatePickerCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className="c-primary" onClick={onClick}>
          {value}
        </button>
    ));
    
    
    return (
        <div className="roe-card-style mt-15 mb-30">
            <div className="roe-card-header row">
                <div style={{width:"40%"}}>
                    <span className="hash"># </span> Cihaz Çizelgesi
                </div>
                <div style={{width:"50%", display:"inline-block", alignSelf:"center"}} className="row">
                    <div className="form-check form-check-inline" style={{padding: "0 15px 0 15px"}}>
                        <DatepickerWrapper>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => {
                                    setTimeAttr('day')
                                    setStartDate(date)
                                    handleQuery({"time": date})
                                }}
                                customInput={<DatePickerCustomInput ref={React.createRef()}/>}
                                className="custom-datepicker"
                                calendarClassName="custom-calender-class"
                                />
                        </DatepickerWrapper>
                    </div>
                    <div className="form-check form-check-inline" style={{padding: "0 15px 0 15px"}}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="week"
                            checked={timeAttr === "week"}
                            onChange={() => {
                                setTimeAttr('week')
                                handleQuery({"time": "week"})
                            }}
                        />
                        <label className="form-check-label">Haftalık</label>
                    </div>
                    <div className="form-check form-check-inline" style={{padding: "0 15px 0 15px"}}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio3"
                            value="month"
                            checked={timeAttr === "month"}
                            onChange={() => {
                                setTimeAttr('month')
                                handleQuery({"time": "month"})
                            }}
                        />
                        <label className="form-check-label">Aylık</label>
                    </div>
                </div>
                <div style={{width:"10%", textAlign:"right"}}>
                    <Dropdown
                        isOpen={dropdownOpen}
                        toggle={() => setDropdownOpen(!dropdownOpen)}
                    >
                        <DropdownToggle caret className="c-primary">{dropdownName}</DropdownToggle>
                        <DropdownMenu>
                            {
                                deviceDataCodes &&
                                Object.entries(deviceDataCodes).map(val => {
                                    return (
                                        <DropdownItem
                                            key={val[0]}
                                            onClick={() => {
                                                setDropdownName(val[1])
                                                handleQuery({"value": val[0]})
                                            }}
                                        >
                                            {val[1]}
                                        </DropdownItem>
                                    )
                                })
                            }
                            
                        </DropdownMenu>
                    </Dropdown>

                </div>
            </div>

            <div className="roe-card-body">
                {/* You can take this configuration for react table customization */}
                <ReactTable
                    data={data}
                    columns={columns}
                    filterable
                    defaultFilterMethod={(filter, row) => {
                        const id = filter.pivotId || filter.id;
                        return row[id] !== undefined
                            ? String(
                                row[id].toLowerCase()
                            ).includes(filter.value.toLowerCase())
                            : true;
                    }}
                    className="-striped -highlight custom-react-table-theme-class"
                    showPagination={false}
                />
                 {/*You can take this configuration for react table customization */}
            </div>
        </div>
    );
};


export default ClientSideTable;
